'use strict'

import {createElements} from "../../functions";
import {createCompareBlock} from "../cards/compareCards";
import {settingsData} from "../../settings";
import { changeLangToCurrent } from '../language/langSwitcher';

export function createCompareCardsButton() {
    const compareButton = createElements('button', ['compare-button', 'language-string', 'button'], document.body, 'afterBegin', {
        data: 'data-dictionary',
        value: 'Compare',
    });

    // compareButton.innerHTML = 'Compare';
    compareButton.innerHTML = changeLangToCurrent('Compare');
    setCompareButtonPosition(compareButton);

    compareButton.addEventListener('click', createCompareBlock);
}

export const setCompareButtonPosition = (button) => {
    if (settingsData.isDesktopMode) return;

    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    const direction = rtl ? 'left' : 'right';
    const rightNavBarWidth = document.querySelector('.right-nav-bar').getBoundingClientRect().width;

    const switcher = document.getElementById('building-switcher');

    if (!switcher.classList.contains('hide')) {
        const switcherWidth = switcher.getBoundingClientRect().width;
        const position = switcherWidth + rightNavBarWidth + 45;
        button.setAttribute('style', `${direction}: ${position}px`);
    } else {
        const position = rightNavBarWidth + 40;
        button.setAttribute('style', `${direction}: ${position}px`);
    }
}